import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const dentallyStatus = async (locationId) => {
  const response = await axiosInstance.get(`${API.DENTALLY.GET_STATUS}${locationId}`);
  return response;
};

export const checkDentallyConnected = async (locationId) => {
  const response = await axiosInstance.get(
    `${API.DENTALLY.CHECK_CONNECTED}?locationId=${locationId}`
  );
  return response;
};

export const connectDentally = async (body, locationId) => {
  const response = await axiosInstance.patch(`${API.DENTALLY.CONNECT}${locationId}`, body);
  return response;
};

export const disconnectDentally = async (locationId) => {
  const response = await axiosInstance.delete(`${API.DENTALLY.DISCONNECT}${locationId}`);
  return response;
};

export const toggleDentallyStatus = async (locationId, dentallyLocationId, status) => {
  const response = await axiosInstance.patch(
    `${API.DENTALLY.TOGGLE_STATUS}${locationId}/${dentallyLocationId}`,
    { status }
  );
  console.log('Toggle status response:', response);
  return response;
};

export const getDentallyServices = async (locationId) => {
  const response = await axiosInstance.get(`${API.DENTALLY.GET_SERVICES}${locationId}`);
  return response;
};

export const mapDentallyServices = async (body) => {
  const response = await axiosInstance.post(API.DENTALLY.MAP_SERVICES, body);
  return response;
};

export const getDentallyLocations = async (locationId) => {
  const response = await axiosInstance.get(`${API.DENTALLY.GET_LOCATIONS}${locationId}`);
  return response;
};

export const getDentallySites = async (locationId, page = 1) => {
  const response = await axiosInstance.get(
    `${API.DENTALLY.GET_DENTALLY_SITES}/${locationId}?page=${page}`
  );
  return response;
};

export const mapDentallyLocations = async (body) => {
  const response = await axiosInstance.post(API.DENTALLY.MAP_LOCATIONS, body);
  return response;
};

export const getDentallyConnection = async (locationId) => {
  const response = await axiosInstance.get(
    `${API.DENTALLY.CHECK_CONNECTED}?locationId=${locationId}`
  );
  return response;
};

export const bindSitePractitioner = async (dentallyLocationId, body) => {
  const response = await axiosInstance.patch(
    `${API.DENTALLY.BIND_SITE_PRACTITIONER}/${dentallyLocationId}`,
    body
  );
  return response;
};

export const getDentallyPractitioners = async (locationId, page = 1) => {
  const response = await axiosInstance.get(
    `${API.DENTALLY.GET_PRACTITIONERS}/${locationId}?page=${page}`
  );
  return response;
};

export const getReasonsMapping = async (locationId) => {
  const response = await axiosInstance.get(`${API.DENTALLY.GET_REASONS_MAPPING}/${locationId}`);
  return response;
};

export const mapService = async (body, locationId) => {
  const response = await axiosInstance.patch(`${API.DENTALLY.MAP_SERVICES}${locationId}`, body);
  return response;
};

export const getCustomFields = async (locationId) => {
  const response = await axiosInstance.get(
    `${API.DENTALLY.GET_CUSTOM_FIELDS}?locationId=${locationId}`
  );
  return response;
};

export const updateCustomFields = async (locationId, payload) => {
  const response = await axiosInstance.patch(
    `${API.DENTALLY.UPDATE_CREATE_PATIENT_PARAMS}/${locationId}`,
    { payload }
  );
  return response;
};

export const getPaymentPlans = async (locationId) => {
  const response = await axiosInstance.get(`${API.DENTALLY.GET_PAYMENT_PLANS}/${locationId}`);
  return response;
};

export const updatePaymentPlan = async (dentallyLocationId, paymentPlanId, paymentPlanName) => {
  const response = await axiosInstance.patch(
    `${API.DENTALLY.BIND_SITE_PRACTITIONER}/${dentallyLocationId}`,
    { paymentPlanId, paymentPlanName }
  );
  return response;
};

export const getDentallyLogs = async (locationId, page = 1, pageSize = 10) => {
  const response = await axiosInstance.get(
    `${API.DENTALLY.GET_LOGS_BY_LOCATION}${locationId}?page=${page}&pageSize=${pageSize}`
  );
  return response;
};

export const retryCreateAppointment = async (logId) => {
  const response = await axiosInstance.post(`${API.DENTALLY.RETRY_CREATE_APPOINTMENT}${logId}`);
  return response;
};
